module.exports = __webpack_public_path__ + "img/(11).0a7f7277.jpg";